import { Controller } from '@hotwired/stimulus'

// TODO: https://stackoverflow.com/questions/61867995/how-to-embed-an-iframe-with-actiontext-trix-on-ruby-on-rails
export default class extends Controller {
  static values = {
    disableFileUpload: { type: Boolean, default: false }
  }

  connect () {
    super.connect()
    if (this.disableFileUploadValue) {
      this.bindOnFileAccept = this.#onFileAccept.bind(this)
      this.element.addEventListener('trix-file-accept', this.bindOnFileAccept)
    }

    this.bindOnBeforeMorphAttribute = this.onBeforeMorphAttribute.bind(this)
    this.bindOnBeforeMorphElement = this.onBeforeMorphElement.bind(this)
    this.bindOnMorphElement = this.onMorphElement.bind(this)

    this.element.addEventListener('turbo:before-morph-attribute', this.bindOnBeforeMorphAttribute)
    this.element.addEventListener('turbo:before-morph-element', this.bindOnBeforeMorphElement)
    this.element.addEventListener('turbo:morph-element', this.bindOnMorphElement)

    this.bindBeforeTrixInitialize = this.beforeTrixInitialize.bind(this)
    this.bindOnTrixInitialize = this.onTrixInitialize.bind(this)
    this.element.addEventListener('trix-before-initialize', this.bindBeforeTrixInitialize)
    this.element.addEventListener('trix-initialize', this.bindOnTrixInitialize)
  }

  disconnect () {
    this.element.removeEventListener('trix-before-initialize', this.bindBeforeTrixInitialize)

    this.element.removeEventListener('turbo:morph-element', this.bindOnMorphElement)
    this.element.removeEventListener('turbo:before-morph-element', this.bindOnBeforeMorphElement)
    this.element.removeEventListener('turbo:before-morph-attribute', this.bindOnBeforeMorphAttribute)

    if (this.disableFileUploadValue) {
      this.element.removeEventListener('trix-file-accept', this.bindOnFileAccept)
    }
    super.disconnect()
  }

  #onFileAccept (event) {
    event.preventDefault()
  }

  onBeforeMorphAttribute (event) {
    const { target } = event

    if ((target.tagName === 'TRIX-EDITOR' && !this.morphTrixEditor) || (target.tagName === 'TRIX-TOOLBAR' && !this.morphTrixToolbar)) {
      event.preventDefault()
    }
  }

  onBeforeMorphElement (event) {
    const { target, detail } = event

    if (target.tagName === 'TRIX-EDITOR') { this.morphTrixEditor = detail.currentElement.id !== detail.newElement?.id }
    if (target.tagName === 'TRIX-TOOLBAR') { this.morphTrixToolbar = detail.currentElement.id !== detail.newElement?.id }

    if ((target.tagName === 'TRIX-EDITOR' && !this.morphTrixEditor) || (target.tagName === 'TRIX-TOOLBAR' && !this.morphTrixToolbar)) {
      console.debug('skip')
      event.preventDefault()
    }
  }

  onMorphElement (event) {
    const { target } = event
    if (target.tagName === 'TRIX-EDITOR' && this.morphTrixEditor) {
      target.reset()
      target.disconnectedCallback()
      target.editorController = null
      target.connectedCallback()
    }
  }

  onTrixInitialize (event) {
    const { target } = event
    const editor = target.editor
    const toolbar = target.editorController.toolbarController
    toolbar.addYoutubeLink = (dialogElement) => {
      const attributeName = dialogElement.getAttribute('data-trix-attribute') || dialogElement.getAttribute('data-trix-dialog-attribute')
      const input = dialogElement.querySelector(`[data-trix-input][name='${attributeName}']`)
      const videoId = this.youtubeId(input.value)

      if (input.willValidate) {
        input.setCustomValidity('')
        if (!input.checkValidity() || !toolbar.isSafeAttribute(input) || !videoId) {
          input.setCustomValidity('Invalid value')
          input.setAttribute('data-trix-validate', '')
          input.classList.add('trix-validate')
          return input.focus()
        }
      }

      editor.insertAttachment(new Trix.Attachment({
        contentType: 'vnd.youtube-attachment',
        content: `
          <span>Hallo Welt</span>
          <iframe width="560" height="315" 
                  src="https://www.youtube.com/embed/${videoId}" title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                  referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>                  
          </iframe>
        `.trim()
      }))
      toolbar.delegate?.render()
      return toolbar.hideDialog()
    }
  }

  youtubeId (link) {
    const result = link.match(/youtube.com\/watch.*?v=([^/?&\s]+)|youtu\.be\/([^/?&]+)/)
    return (result === null) ? undefined : (result[1] || result[2])
  }

  beforeTrixInitialize (event) {
    /* global Trix */
    Trix.config.blockAttributes.heading4 = {
      tagName: 'h4',
      terminal: true,
      breakOnReturn: true
    }
    Trix.config.blockAttributes.heading5 = {
      tagName: 'h5',
      terminal: true,
      breakOnReturn: true
    }

    Trix.config.attachments.preview.caption.name = false
    Trix.config.attachments.preview.caption.size = false
    Trix.config.attachments.file.caption.size = false

    Trix.config.toolbar.getDefaultHTML = () => {
      const { lang } = Trix.config

      return `
        <div class="flex gap-2">
          <span class="join trix-button-group--text-tools" data-trix-button-group="text-tools">
            <button type="button" class="btn join-item" data-trix-attribute="bold" data-trix-key="b" title="${lang.bold}" tabindex="-1">
              <i class="far fa-bold"></i>
            </button>
            <button type="button" class="btn join-item" data-trix-attribute="italic" data-trix-key="i" title="${lang.italic}" tabindex="-1">
              <i class="far fa-italic"></i>
            </button>
            <button type="button" class="btn join-item" data-trix-attribute="strike" title="${lang.strike}" tabindex="-1">
              <i class="far fa-strikethrough"></i>
            </button>
            <button type="button" class="btn join-item" data-trix-attribute="href" data-trix-action="link" data-trix-key="k" title="${lang.link}" tabindex="-1">
              <i class="far fa-link"></i>
            </button>
          </span>
    
          <span class="join trix-button-group--block-tools" data-trix-button-group="block-tools">
            <button type="button" class="btn join-item" data-trix-attribute="heading4" title="${lang.heading4}" tabindex="-1">
              <i class="far fa-heading"></i>
              <i class="far fa-4 fa-xs"></i>
            </button>
            <button type="button" class="btn join-item" data-trix-attribute="heading5" title="${lang.heading5}" tabindex="-1">
              <i class="far fa-heading"></i>
              <i class="far fa-5 fa-xs"></i>
            </button>
            <button type="button" class="btn join-item" data-trix-attribute="quote" title="${lang.quote}" tabindex="-1">
              <i class="far fa-quote-left"></i>
            </button>
            <button type="button" class="btn join-item" data-trix-attribute="bullet" title="${lang.bullets}" tabindex="-1">
              <i class="far fa-list-ul"></i>
            </button>
            <button type="button" class="btn join-item" data-trix-attribute="number" title="${lang.numbers}" tabindex="-1">
              <i class="far fa-list-ol"></i>
            </button>
            <button type="button" class="btn join-item" data-trix-action="decreaseNestingLevel" title="${lang.outdent}" tabindex="-1">
              <i class="far fa-outdent"></i>
            </button>
            <button type="button" class="btn join-item" data-trix-action="increaseNestingLevel" title="${lang.indent}" tabindex="-1">
              <i class="far fa-indent"></i>
            </button>
          </span>
    
          <span class="trix-button-group--file-tools" data-trix-button-group="file-tools">
            <button type="button" class="btn" data-trix-action="attachFiles" title="${lang.attachFiles}" tabindex="-1">
              <i class="far fa-paperclip-vertical"></i>
            </button>
<!--            <button type="button" class="btn" data-trix-attribute="youtube" data-trix-action="addYoutubeLink" title="${lang.youtube}" tabindex="-1">
              <i class="fab fa-youtube"></i>
            </button>-->
          </span>
    
          <span class="grow"></span>
    
          <span class="join trix-button-group--history-tools" data-trix-button-group="history-tools">
            <button type="button" class="btn join-item" data-trix-action="undo" data-trix-key="z" title="${lang.undo}" tabindex="-1">
              <i class="far fa-undo"></i>
            </button>
            <button type="button" class="btn join-item" data-trix-action="redo" data-trix-key="shift+z" title="${lang.redo}" tabindex="-1">
              <i class="far fa-redo"></i>
            </button>
          </span>
        </div>
    
        <div class="trix-dialogs" data-trix-dialogs>
          <div class="absolute menu rounded-box bg-white shadow w-150 z-1 trix-dialog--link" data-trix-dialog="href" data-trix-dialog-attribute="href">
            <div class="trix-dialog__link-fields">
              <div class="join w-full">
                <input type="url" name="href" class="join-item input grow" placeholder="${lang.urlPlaceholder}"
                       aria-label="${lang.url}" data-trix-validate-href required data-trix-input/>
                <input type="button" class="join-item btn" value="${lang.link}" data-trix-method="setAttribute"/>
                <input type="button" class="join-item btn" value="${lang.unlink}" data-trix-method="removeAttribute"/>
              </div>
            </div>
          </div>
          <div class="absolute menu rounded-box bg-white shadow w-150 z-1 trix-dialog--youtube" data-trix-dialog="youtube" data-trix-dialog-attribute="youtube">
            <div class="trix-dialog__youtube-fields">
              <div class="join w-full">
                <input type="url" name="youtube" class="join-item input grow" placeholder="${lang.urlPlaceholder}"
                       aria-label="${lang.url}" data-trix-validate-href required data-trix-input/>
                <input type="button" class="join-item btn" value="${lang.add}" data-trix-method="addYoutubeLink"/>
              </div>
            </div>
          </div>
        </div>
      `
    }
  }
}
